import React, {Suspense} from 'react'

import range from 'lodash/range'

import Slider from 'rc-slider';

import i18next from 'i18next'

import { NeuroFitLogoSvg } from '../../constants/svgs'

import {
  formatNumber,
  isRtlLanguage,
} from '../../languageUtils'

const SliderSection = ({
  title,
  subtitle,
  value,
  onChange,
  onAfterChange,
  min,
  max,
  isDisabled,
  marginTop,
  disableRtl,
  color
}) => {
  const isRtl = (!disableRtl) && isRtlLanguage()
  return (
    <div>
      <div className="lp-header" style={{fontSize: "min(6vw, 24px)", textTransform: "uppercase", marginTop: marginTop, color: color || "#000000"}}>
        {`${title}: ${formatNumber(value || 0)}/${formatNumber(max)}`}
      </div>
      <div style={{display: "flex", alignItems: "top", justifyContent: "start", marginTop: "1vh", marginBottom: "2vh"}}>
        <div style={{display: "inline-block", fontSize: "min(5vw, 18px)", textAlign: "start", fontFamily: "Futura Light", color: color || "#000000"}}>
          {subtitle}
        </div>
      </div>
      <div style={{width: "calc(100% - 30px)"}}>
        <Slider
          value={value || min}
          onChange={(val) => {
            onChange(val)
          }}
          reverse={isRtl}
          onChangeComplete={val => {
            onAfterChange(val)
          }}
          min={min}
          max={max}
          disabled={isDisabled}
          railStyle={{backgroundColor: "#CFD2DD", height: 3, borderRadius: 0}}
          trackStyle={{backgroundColor: "#000000", height: 3, borderRadius: 0}}
          handleStyle={{opacity: 0, height: 50, width: 50, top: 0, transform: "none", marginTop: "none"}}
          handleRender={(node, props) => {
            return (
              <div className={"rc-slider-handle"} style={{height: 50, width: 50, position: "relative", marginTop: 0, insetInlineStart: `${value / (max / 100.0)}%`, transform: isRtl ? "translate(50%, -50%)" : "translate(-50%, -50%)", border: "none", boxShadow: "none", opacity: 1, backgroundColor: "transparent"}}>
                <div
                  style={{color: "#FFFFFF", top: 15, insetInlineStart: 15, position: "absolute", backgroundColor: props.dragging ? "#555555" : "#000000", position: "relative", fontSize: 10, height: 20, width: 20, textAlign: "center", fontFamily: "Futura Medium", borderRadius: "50%"}}
                >
                {node}
                </div>
              </div>
            )
          }}
        />
      </div>
    </div>
  );
}

export default SliderSection;